// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import type { GetListingPhotosUploadPresenter } from "../types";

const getListingUploadPhotos = (
  listingId: number
): ((
  apiInstance: AxiosInstance
) => AxiosPromise<GetListingPhotosUploadPresenter>) => (apiInstance) => {
  return apiInstance.get(`/v4/listings/${listingId}/upload`);
};

export default getListingUploadPhotos;
